function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defineComponent, inject, ref, computed, unref, watch, onMounted, provide, openBlock, createElementBlock, normalizeStyle, normalizeClass, renderSlot, createVNode, withCtx, Fragment, createTextVNode, toDisplayString, createCommentVNode } from 'vue';
import { offset } from '@floating-ui/dom';
import '../../../hooks/index.mjs';
import '../../visual-hidden/index.mjs';
import { tooltipV2RootKey, tooltipV2ContentKey } from './constants.mjs';
import { tooltipV2ContentProps } from './content.mjs';
import { tooltipV2CommonProps } from './common.mjs';
import _export_sfc from '../../../_virtual/plugin-vue_export-helper.mjs';
import { useFloating, arrowMiddleware } from '../../../hooks/use-floating/index.mjs';
import { useZIndex } from '../../../hooks/use-z-index/index.mjs';
import { useNamespace } from '../../../hooks/use-namespace/index.mjs';
import ElVisuallyHidden from '../../visual-hidden/src/visual-hidden2.mjs';
const _hoisted_1 = ["data-side"];
const __default__ = defineComponent({
  name: "ElTooltipV2Content"
});
const _sfc_main = /* @__PURE__ */defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  props: _objectSpread(_objectSpread({}, tooltipV2ContentProps), tooltipV2CommonProps),
  setup(__props) {
    const props = __props;
    const _inject = inject(tooltipV2RootKey),
      triggerRef = _inject.triggerRef,
      contentId = _inject.contentId;
    const placement = ref(props.placement);
    const strategy = ref(props.strategy);
    const arrowRef = ref(null);
    const _useFloating = useFloating({
        placement,
        strategy,
        middleware: computed(() => {
          const middleware = [offset(props.offset)];
          if (props.showArrow) {
            middleware.push(arrowMiddleware({
              arrowRef
            }));
          }
          return middleware;
        })
      }),
      referenceRef = _useFloating.referenceRef,
      contentRef = _useFloating.contentRef,
      middlewareData = _useFloating.middlewareData,
      x = _useFloating.x,
      y = _useFloating.y,
      update = _useFloating.update;
    const zIndex = useZIndex().nextZIndex();
    const ns = useNamespace("tooltip-v2");
    const side = computed(() => {
      return placement.value.split("-")[0];
    });
    const contentStyle = computed(() => {
      return {
        position: unref(strategy),
        top: `${unref(y) || 0}px`,
        left: `${unref(x) || 0}px`,
        zIndex
      };
    });
    const arrowStyle = computed(() => {
      if (!props.showArrow) return {};
      const _unref = unref(middlewareData),
        arrow = _unref.arrow;
      return {
        [`--${ns.namespace.value}-tooltip-v2-arrow-x`]: `${arrow == null ? void 0 : arrow.x}px` || "",
        [`--${ns.namespace.value}-tooltip-v2-arrow-y`]: `${arrow == null ? void 0 : arrow.y}px` || ""
      };
    });
    const contentClass = computed(() => [ns.e("content"), ns.is("dark", props.effect === "dark"), ns.is(unref(strategy)), props.contentClass]);
    watch(arrowRef, () => update());
    watch(() => props.placement, val => placement.value = val);
    onMounted(() => {
      watch(() => props.reference || triggerRef.value, el => {
        referenceRef.value = el || void 0;
      }, {
        immediate: true
      });
    });
    provide(tooltipV2ContentKey, {
      arrowRef
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "contentRef",
        ref: contentRef,
        style: normalizeStyle(unref(contentStyle)),
        "data-tooltip-v2-root": ""
      }, [!_ctx.nowrap ? (openBlock(), createElementBlock("div", {
        key: 0,
        "data-side": unref(side),
        class: normalizeClass(unref(contentClass))
      }, [renderSlot(_ctx.$slots, "default", {
        contentStyle: unref(contentStyle),
        contentClass: unref(contentClass)
      }), createVNode(unref(ElVisuallyHidden), {
        id: unref(contentId),
        role: "tooltip"
      }, {
        default: withCtx(() => [_ctx.ariaLabel ? (openBlock(), createElementBlock(Fragment, {
          key: 0
        }, [createTextVNode(toDisplayString(_ctx.ariaLabel), 1)], 64)) : renderSlot(_ctx.$slots, "default", {
          key: 1
        })]),
        _: 3
      }, 8, ["id"]), renderSlot(_ctx.$slots, "arrow", {
        style: normalizeStyle(unref(arrowStyle)),
        side: unref(side)
      })], 10, _hoisted_1)) : createCommentVNode("v-if", true)], 4);
    };
  }
}));
var TooltipV2Content = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "content.vue"]]);
export { TooltipV2Content as default };